import { createSelector } from "reselect";

import { selectIsNewOnlyEnabled } from "app/pages/sales-intelligence/modules/advanced-search-filtering/store/selectors";
import { selectSearchText as selectLeadsSearchText } from "app/pages/sales-intelligence/modules/leads-search/store/selectors";
import type { LeadsSearchState } from "app/pages/sales-intelligence/modules/leads-search/store/types";
import { selectFiltersValueDeepEqual } from "app/pages/sales-intelligence/modules/leads-search-filters/store/selectors";
// TODO: cross-module dependency — move to page-level composition when leads-search / apps-search boundaries are untangled
import { selectSalesIntelligenceState } from "app/pages/sales-intelligence/store/selectors";
import { createStatePropertySelector } from "app/pages/workspace/sales/helpers";

import type { AppsSearchTableState } from "./types";

const selectAppsSearchState = createStatePropertySelector<AppsSearchTableState>(
    selectSalesIntelligenceState("appsSearch"),
);

const selectIsAggregatedDataUsed = createStatePropertySelector<LeadsSearchState>(
    selectSalesIntelligenceState("leadsSearch"),
)("isAggregatedDataUsed");

export const selectAppsTableParams = selectAppsSearchState("tableParams");

export const selectAppsSearchText = selectAppsSearchState("searchText");

export const selectAppsIsRowSelectionEnabled = selectAppsSearchState("isRowSelectionEnabled");

export const selectAppsSelectedRows = selectAppsSearchState("selectedRows");

export const selectAppsSelectedRowKeys = createSelector([selectAppsSelectedRows], (selectedRows) =>
    selectedRows.map((row) => row.key),
);

export const selectAppsSearchRequestDto = createSelector(
    [
        selectAppsTableParams,
        selectFiltersValueDeepEqual,
        selectAppsSearchText,
        selectLeadsSearchText,
        selectIsNewOnlyEnabled,
        selectIsAggregatedDataUsed,
    ],
    (tableParams, queryFilters, searchText, leadsSearchText, isNewOnly, leadGenTrafficAggregationEnabled) => {
        return {
            ...tableParams,
            isNewOnly,
            leadGenTrafficAggregationEnabled,
            queryFilters: {
                ...queryFilters,
                appsFilters: {
                    ...queryFilters.appsFilters,
                    ...(searchText ? { searchText } : {}),
                },
                ...(leadsSearchText
                    ? {
                          leadsFilters: {
                              ...queryFilters.leadsFilters,
                              searchText: leadsSearchText,
                          },
                      }
                    : {}),
            },
        };
    },
);
